import type { FC } from 'react';
import { lazy } from 'react';

const Page = lazy(() => import('./page'));

export const GoodbyeAggregateEu: FC = () => <Page />;
